import {Injectable} from '@angular/core';
import {MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {Store} from '@ngrx/store';
import {CurrentCmcVersionAction, NotifyUserForCmcVersionChange, StandaloneState} from '../../store/standalone';
import {selectStandaloneState} from '../../store';
import {firstValueFrom, of} from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import JSZip from 'jszip';
import {catchError} from 'rxjs/operators';
import {CmcProductManagerDatabase} from "../../sqllite/databases/cmc-product-manager.database";

@Injectable({
    providedIn: 'root'
})export class CmcCollectionsSynchronizer {
    private countryIsoCode:string;

    constructor(private readonly store: Store<StandaloneState>,
                private readonly messageService: MessageService,
                private readonly translateService: TranslateService,
                private readonly cmcProductManagerDatabase: CmcProductManagerDatabase,
                private httpClient: HttpClient) {
    }

    public async init(countryIsoCode: string) {
        this.countryIsoCode = countryIsoCode;
        console.log("INIT CmcCollectionsSynchronizer")
        if(! await this.cmcProductManagerDatabase.exists()) {
            console.log("INIT !existingDb CmcCollectionsSynchronizer lunch synchronizeNewVersion ...")
            await this.synchronizeCmcProducts();
        }
        this.notifyCmcVersionChange();
    }

    async synchronizeCmcProducts() {
        console.time('synchronizeCmcProducts');
        const storedEtag = (await firstValueFrom(this.store.select(selectStandaloneState))).currentCmcVersion || '';
        const headers = storedEtag ? { 'If-None-Match': storedEtag } : {};
        const response = await  firstValueFrom(
            this.httpClient
            .get(`/apiCmcProductManager/v1/sync/download/${this.countryIsoCode}/latest`,
                { headers: new HttpHeaders(headers), observe: 'response', responseType: 'blob' })
                .pipe(catchError(err => of(err)))
        );
        if (response.status === 200 && response.headers.has('ETag')) {
            const zip = await JSZip.loadAsync(response.body!);
            const fileName = Object.keys(zip.files)[0];
            const dbFile = await zip.files[fileName].async('uint8array');
            await this.cmcProductManagerDatabase.saveAndLoadDb(dbFile);
            if(storedEtag !== '') {
                this.store.dispatch(new NotifyUserForCmcVersionChange(true));
            }
            this.store.dispatch(new CurrentCmcVersionAction(response.headers.get('ETag')));
        }else if (response.status === 304) {
            console.log('Fichier des cmc articles déjà à jour, pas besoin de retélécharger.');
        }
        console.timeEnd('synchronizeCmcProducts');
    }

    private notifyCmcVersionChange() {
        this.store.select(selectStandaloneState).subscribe((standaloneState:StandaloneState) => {
            if(standaloneState.notifyCmcVersionChange) {
                this.messageService.add({
                    severity: 'info',
                    detail: this.translateService.instant('NEW_CMC_DATABASE_IS_CHARGED'),
                    life: 20000,
                    closable: true,
                    key: 'noDuplicateToast'
                });
                this.store.dispatch(new NotifyUserForCmcVersionChange(false));
            }
        });
    }

}

